import {connect} from 'react-redux';

import {makeMapDispatchToProps, makeMapStateToProps} from '../../../../srcCommon/helpers/reselectHelpers';
import {fetchAccountsSetupGuideCompletedTasksAsyncAction} from '../../../store/data/accounts/accountsActions';
import {getAccountsSetupGuideCompletedTasks} from '../../../store/data/localPreferences/localPreferencesSelectors';
import {updateHasDismissedAccountsSetupGuideAction} from '../../../store/data/preferences/preferencesActions';
import {getHasDismissedAccountsSetupGuide} from '../../../store/data/preferences/preferencesSelectors';
import {AccountsSetupGuide} from './accountsSetupGuide';

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps()(() => ({
  accountsSetupGuideCompletedTasks: getAccountsSetupGuideCompletedTasks,
  hasDismissedAccountsSetupGuide: getHasDismissedAccountsSetupGuide,
}));

const mapDispatchToProps = makeMapDispatchToProps()(() => ({
  fetchAccountsSetupGuideCompletedTasksAsync: fetchAccountsSetupGuideCompletedTasksAsyncAction,
  updateHasDismissedAccountsSetupGuide: updateHasDismissedAccountsSetupGuideAction,
}));

export const AccountsSetupGuideContainer = connect(mapStateToProps, mapDispatchToProps)(AccountsSetupGuide);
